import Ordina from "./Ordina";
export default Ordina;